import type { ReactNode } from "react";

import css from "./ControlBox.module.css";

export function ControlBox(props: {
  children: ReactNode;
  title: string;
  reset?: () => void;
}) {
  return (
    <div className={css.root}>
      <div className={css.top}>
        <div className={css.title}>{props.title}:</div>
        {props.reset && (
          <button className={css.reset} onClick={props.reset}>
            reset
          </button>
        )}
      </div>
      <div>{props.children}</div>
    </div>
  );
}
